<template>
    <CicPopup
        :title="item.profileId ? 'Edit FTP Profile' : 'Add FTP Profile'"
        saveable
        @blur="$emit('blur')"
        @input="$emit('input')"
    >
        <div class="item-form">
            <ul>
                <li class="form-label-first">
                    {{ $t('Profile Name') }}
                </li>
                <li>
                    <CicTextbox
                        id="profile_name"
                        :value="item.name"
                        :maxlength="64"
                        @input="(val) => updateFieldValue('name', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Server Address') }}
                </li>
                <li>
                    <CicTextbox
                        id="profile_server"
                        :value="item.server"
                        :maxlength="128"
                        @input="(val) => updateFieldValue('server', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Subfolder') }}
                </li>
                <li>
                    <CicTextbox
                        id="profile_subfolder"
                        :value="item.subfolder"
                        :maxlength="128"
                        clearable
                        @input="(val) => updateFieldValue('subfolder', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Username') }}
                </li>
                <li>
                    <CicTextbox
                        id="profile_username"
                        :value="item.username"
                        :maxlength="50"
                        @input="(val) => updateFieldValue('username', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Password') }}
                </li>
                <li>
                    <CicTextbox
                        id="profile_password"
                        :value="item.password"
                        :maxlength="1024"
                        type="password"
                        @input="(val) => updateFieldValue('password', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Confirm Password') }}
                </li>
                <li>
                    <CicTextbox
                        id="profile_password2"
                        :value="item.password2"
                        :maxlength="1024"
                        type="password"
                        @input="(val) => updateFieldValue('password2', val)"
                    />
                </li>
            </ul>
        </div>
    </CicPopup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'EditFTPProfile',
        components: {
            CicPopup,
            CicTextbox,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'change', 'input'],
        methods: {
            updateFieldValue(field, val) {
                this.$emit('change', field, val);
            },
        },
    };
</script>
